var sound_control_rtlignore_default = {
  "root": "mq8J3",
  "sliderContainer": "M-3Q5"
};
export {
  sound_control_rtlignore_default as default
};
//# sourceMappingURL=sound-control.rtlignore-scss.js.map
